import { createAppWrap } from '../../create_app_wrap';
import mixin from './_mixin';

const view = '[data-view="item-edit"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // デザイン設定画面
                disp_design_edit: false,
            };
        },
        computed: {
            // 表示ステップ番号
            step: {
                get() {
                    return (this.disp_design_edit) ? 2 : 1;
                },
                set(value) {
                    this.disp_design_edit = (value === 2);
                },
            },
        },
        mixins: [
            mixin,
        ],
        methods: {
            // ヤフーTOKEN認証チェック後にデータ取得
            isValidToken: async function (boolean) {
                if (boolean) {
                    const itemCode = this.$_params('item_code');
                    await this.setItemData(itemCode);
                }
            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}
